import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { X, ArrowUpRight } from "lucide-react";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Logo from "../assets/images/logo.png";
import toast from 'react-hot-toast';
import "../styles/landing.scss";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// ✅ Yup Validation Schema
const validationSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .matches(/^\S.*$/, "Name cannot start with a space")
    .required("Name is required"),
  email: Yup.string()
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email (no spaces allowed)")
    .required("Email is required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile must be exactly 10 digits")
    .required("Mobile number is required"),
  message: Yup.string()
    .trim()
    .matches(/^\S.*$/, "Message cannot start with a space")
    .required("Message is required"),
});

const EnquiryModal = ({ show, handleClose }) => {
  const [hovered, setHovered] = useState(false);

  // ✅ Submit
  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = await fetch(`${BASE_URL}/api/superadmin/enquiry`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success("Enquiry submitted successfully!");
        resetForm();
        handleClose(); // ✅ close modal via parent
      } else {
        toast.error(data.message || "Submission failed");
      }
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        backdrop="static"
        dialogClassName="enquiry-modal"
      >
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center p-3 enquiry-header">
          <div className="d-flex align-items-center">
            <img src={Logo} alt="HospEase" height={40} className="me-2" />
          </div>
          <X role="button" onClick={handleClose} />
        </div>

        {/* Body */}
        <Modal.Body className="p-4">
          <h4 className="fw-bold text-center mb-4 text-teal">
            Let’s Connect Today
          </h4>

           <Formik
            initialValues={{ name: "", email: "", mobile: "", message: "" }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, setFieldValue }) => (
              <FormikForm noValidate>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Name</Form.Label>
                  <Field
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Enter your name"
                    onKeyDown={(e) => {
                    const input = e.target;
                    const value = input.value;

                    if (e.key === " " && value.length === 0) {
                      e.preventDefault(); // only block space if it's the first character
                    }
                  }}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger small"
                    onKeyDown={(e) => {
                    if (e.key === " ") {
                      e.preventDefault(); // space enter hone se rok dega
                    }
                  }}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Email</Form.Label>
                  <Field
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Enter your email"
                    onKeyDown={(e) => {
                    if (e.key === " ") {
                      e.preventDefault(); // space enter hone se rok dega
                    }
                  }}
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-danger small"
                    onKeyDown={(e) => {
                    if (e.key === " ") {
                      e.preventDefault(); // space enter hone se rok dega
                    }
                  }}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Mobile No.</Form.Label>
                  <Field
                    type="text"
                    name="mobile"
                    className="form-control"
                    placeholder="Enter 10-digit mobile number"
                    onInput={(e) => {
                       if (e.key === " ") {
                        e.preventDefault(); // space enter hone se rok dega
                      }
                      e.target.value = e.target.value.replace(/\D/g, ""); // allow digits only
                      setFieldValue("mobile", e.target.value);
                    }}
                    maxLength={10}
                  />
                  <ErrorMessage
                    name="mobile"
                    component="div"
                    className="text-danger small"
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="fw-bold">Message</Form.Label>
                  <Field
                    as="textarea"
                    name="message"
                    className="form-control"
                    rows={3}
                    placeholder="Enter your message"
                    onKeyDown={(e) => {
                    const input = e.target;
                    const value = input.value;

                    if (e.key === " " && value.length === 0) {
                      e.preventDefault(); // only block space if it's the first character
                    }
                  }}
                  />
                  <ErrorMessage
                    name="message"
                    component="div"
                    className="text-danger small"
                  />
                </Form.Group>

                <div className="text-center">
                  <Button
                    type="submit"
                    className="px-5 py-2 fw-bold enquiry-submit-btn"
                    disabled={isSubmitting}
                  >
                    Submit
                  </Button>
                </div>
              </FormikForm>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};


export default EnquiryModal;
